
    import _Handlebars from 'handlebars/runtime';

    var Handlebars = _Handlebars.default;
    import "@canvas/i18n";
import "@canvas/handlebars-helpers/index.js";

    var template = Handlebars.template, templates = Handlebars.templates = Handlebars.templates || {};
    var name = '/var/canvas/ui/features/account-admin-tools/jst/UserSearchResults';
    templates[name] = template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  var buffer = "", stack1, functionType="function", escapeExpression=this.escapeExpression, helperMissing=helpers.helperMissing, self=this;

function program1(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n<div class=\"admin-tool-well\">\n  <div class=\"h2\">\n    <span class=\"lead\">";
  if (helper = helpers.name) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.name); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "</span>\n    <p>\n    <strong>"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("accounts.admin_tools.user_search_results")
  },data:data},helper ? helper.call(depth0, "user_id_b5bcb066", "User ID:", options) : helperMissing.call(depth0, "t", "user_id_b5bcb066", "User ID:", options)))
    + "</strong> ";
  if (helper = helpers.id) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.id); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + " <br />\n    <strong>"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("accounts.admin_tools.user_search_results")
  },data:data},helper ? helper.call(depth0, "user_sis_id_ce5d7a46", "User SIS ID:", options) : helperMissing.call(depth0, "t", "user_sis_id_ce5d7a46", "User SIS ID:", options)))
    + "</strong> ";
  if (helper = helpers.sis_user_id) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.sis_user_id); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "<br />\n    </p>\n  </div>\n  <button id=\"restoreUserBtn\" class=\"btn\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("accounts.admin_tools.user_search_results")
  },data:data},helper ? helper.call(depth0, "restore_6d523f1d", "Restore", options) : helperMissing.call(depth0, "t", "restore_6d523f1d", "Restore", options)))
    + "</button>&nbsp;&nbsp;<span>"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("accounts.admin_tools.user_search_results")
  },data:data},helper ? helper.call(depth0, "accounts.admin_tools.user_search_results.info_text", "Enrollments, communication channels, and observers must be restored manually.", options) : helperMissing.call(depth0, "t", "accounts.admin_tools.user_search_results.info_text", "Enrollments, communication channels, and observers must be restored manually.", options)))
    + "</span>\n</div>\n";
  return buffer;
  }

function program3(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n<div class=\"alert alert-error\">\n  <p class=\"text-error no-spacing\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("accounts.admin_tools.user_search_results")
  },data:data},helper ? helper.call(depth0, "a_deleted_user_with_that_id_could_not_be_found_for_57503c7b", "A deleted user with that ID could not be found for this account.", options) : helperMissing.call(depth0, "t", "a_deleted_user_with_that_id_could_not_be_found_for_57503c7b", "A deleted user with that ID could not be found for this account.", options)))
    + "</p>\n</div>\n";
  return buffer;
  }

function program5(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n<div class=\"alert alert-success\" role=\"alert\">\n  <p class=\"lead\">\n  ";
  if (helper = helpers.name) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.name); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + " has been restored!\n  </p>\n  <div>\n    <strong>"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("accounts.admin_tools.user_search_results")
  },data:data},helper ? helper.call(depth0, "what_would_you_like_to_do_next_2835397e", "What would you like to do next?", options) : helperMissing.call(depth0, "t", "what_would_you_like_to_do_next_2835397e", "What would you like to do next?", options)))
    + "</strong>\n    <div>\n      <a href=\"users/";
  if (helper = helpers.id) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.id); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\" id=\"viewUser\" class=\"btn\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("accounts.admin_tools.user_search_results")
  },data:data},helper ? helper.call(depth0, "view_user_8b1082bc", "View User", options) : helperMissing.call(depth0, "t", "view_user_8b1082bc", "View User", options)))
    + "</a>\n    </div>\n  </div>\n</div>\n";
  return buffer;
  }

function program7(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n<div class=\"alert alert-block\">\n  <div class=\"h2\">\n    <span class=\"lead\">";
  if (helper = helpers.name) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.name); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + " "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("accounts.admin_tools.user_search_results")
  },data:data},helper ? helper.call(depth0, "not_deleted_2a7f63ef", "(Not Deleted)", options) : helperMissing.call(depth0, "t", "not_deleted_2a7f63ef", "(Not Deleted)", options)))
    + "</span>\n    <p>\n    <strong>"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("accounts.admin_tools.user_search_results")
  },data:data},helper ? helper.call(depth0, "user_id_b5bcb066", "User ID:", options) : helperMissing.call(depth0, "t", "user_id_b5bcb066", "User ID:", options)))
    + "</strong> ";
  if (helper = helpers.id) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.id); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + " <br />\n    <strong>"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("accounts.admin_tools.user_search_results")
  },data:data},helper ? helper.call(depth0, "user_login_id_7d5a6d2a", "User login ID:", options) : helperMissing.call(depth0, "t", "user_login_id_7d5a6d2a", "User login ID:", options)))
    + "</strong> ";
  if (helper = helpers.login_id) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.login_id); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "<br />\n    <strong>"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("accounts.admin_tools.user_search_results")
  },data:data},helper ? helper.call(depth0, "user_sis_id_ce5d7a46", "User SIS ID:", options) : helperMissing.call(depth0, "t", "user_sis_id_ce5d7a46", "User SIS ID:", options)))
    + "</strong> ";
  if (helper = helpers.sis_user_id) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.sis_user_id); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "<br />\n    </p>\n  </div>\n\n  <div>\n    <div>\n      <a href=\"users/";
  if (helper = helpers.id) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.id); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\" id=\"viewUser\" class=\"btn\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("accounts.admin_tools.user_search_results")
  },data:data},helper ? helper.call(depth0, "view_user_8b1082bc", "View User", options) : helperMissing.call(depth0, "t", "view_user_8b1082bc", "View User", options)))
    + "</a>\n    </div>\n  </div>\n\n</div>\n";
  return buffer;
  }

  stack1 = helpers['if'].call(depth0, (depth0 && depth0.showRestore), {hash:{},inverse:self.noop,fn:self.program(1, program1, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n\n";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.showNotFound), {hash:{},inverse:self.noop,fn:self.program(3, program3, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n\n";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.showSuccessfullRestore), {hash:{},inverse:self.noop,fn:self.program(5, program5, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n\n";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.showNonDeletedUser), {hash:{},inverse:self.noop,fn:self.program(7, program7, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n";
  return buffer;
  });
    ;
    ;
    export default templates[name];
  